<!--
 * @Description: 常规工作/日常事务 听课记录 列表页
 * @Author: 王赵坤
 * @Date: 2022-12-28 15:57:15
 * @LastEditors: PF
 * @LastEditTime: 2024-06-19 10:46:05
-->
<template>
  <div>
    <el-dialog class="wp90 hp90" v-model="openList" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Edit />
          </el-icon>
          <span class="header-title">听课记录</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="openList=false;homeCloseWindow('openReturn', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <div class="list-page pl0 pr0 pt0 pb0">
        <el-container>
          <el-header>
            <!-- 搜索区域 BEGIN -->
            <el-form class="search-box" :model="dataGrid.parms" @submit.enter.prevent>
              <el-form-item>
                <el-input placeholder="听课教职工姓名" v-model="dataGrid.parms.tkjzgxm" clearable @clear="bindTable()" @keyup.enter="bindTable()">
                  <template #suffix>
                    <el-icon class="el-input__icon pointer" @click="bindTable()">
                      <search />
                    </el-icon>
                  </template>
                </el-input>
              </el-form-item>
              <el-form-item>
                <el-input placeholder="授课教职工姓名" v-model="dataGrid.parms.skjsxms" clearable @clear="bindTable()" @keyup.enter="bindTable()">
                  <template #suffix>
                    <el-icon class="el-input__icon pointer" @click="bindTable()">
                      <search />
                    </el-icon>
                  </template>
                </el-input>
              </el-form-item>
              <el-form-item>
                <el-input placeholder="课程名称" class="filter-item" v-model="dataGrid.parms.kcmc" clearable @clear="bindTable()" @keyup.enter="bindTable()">
                  <template #suffix>
                    <el-icon class="el-input__icon pointer" @click="bindTable()">
                      <search />
                    </el-icon>
                  </template>
                </el-input>
              </el-form-item>
            </el-form>
            <div class="button-box">
              <el-button class="w200" type="primary" @click="openAdd=true"><span class="iconfont icon-chuangjian"></span>添加</el-button>
            </div>
            <!-- 按钮区域 END -->
          </el-header>
          <el-main>
            <!-- 列表区域 -->
            <el-table :data="dataGrid.data" :default-sort="dataGrid.orderBy" v-loading="dataGrid.loading" @sort-change="dataGrid.sortChange" @selection-change="dataGrid.selectionChange" height="100%" border stripe>
              <el-table-column type="index" label="序号" align="center" width="80" />
              <el-table-column prop="skjsxms" label="授课教师" align="center" show-overflow-tooltip :sort-orders="['ascending', 'descending']" />
              <el-table-column prop="bjmc" label="班级" align="center" show-overflow-tooltip :sort-orders="['ascending', 'descending']" />
              <el-table-column prop="xq" label="星期" align="center" show-overflow-tooltip>
                <template #default="scope">
                  星期<span v-if="scope.row.xq == 1">一</span>
                  <span v-if="scope.row.xq == 2">二</span>
                  <span v-if="scope.row.xq == 3">三</span>
                  <span v-if="scope.row.xq == 4">四</span>
                  <span v-if="scope.row.xq == 5">五</span>
                  <span v-if="scope.row.xq == 6">六</span>
                  <span v-if="scope.row.xq == 7">日</span>
                </template>
              </el-table-column>
              <el-table-column prop="jc" label="节次" align="center" show-overflow-tooltip>
                <template #default="scope">
                  第{{scope.row.jc}}节
                </template>
              </el-table-column>
              <el-table-column prop="kcmc" label="课程" align="center" show-overflow-tooltip :sort-orders="['ascending', 'descending']" />
              <el-table-column fixed="right" prop="tkrq" label="听课日期" align="center" show-overflow-tooltip :sort-orders="['ascending', 'descending']" />
              <!-- <el-table-column fixed="right" prop="jxcds" label="地点" show-overflow-tooltip align="center" /> -->
              <el-table-column fixed="right" label="操作" align="center" width="250">
                <template #default="scope">
                  <el-button link type="success" @click="openDetail=true; row=scope.row">详情</el-button>
                  <el-button link type="primary" @click="openEdit=true; row=scope.row">修改</el-button>
                  <el-button link type="warning" @click="dataGrid.multipleSelection=[scope.row.id]; remove()">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-main>
          <!-- 分页 -->
          <el-footer>
            <pagination :pagination="dataGrid.pagination" @ReturnData="bindTable" />
          </el-footer>
        </el-container>
      </div>
    </el-dialog>
  </div>
  <add v-if="openAdd" v-model:openAdd="openAdd" @ReturnData="bindTable" />
  <edit v-if="openEdit" v-model:openEdit="openEdit" :row="row" @ReturnData="bindTable" />
  <detail v-if="openDetail" v-model:openDetail="openDetail" :row="row" />
</template>

<script setup>
import { defineEmits, ref, defineProps, watch } from 'vue'
import { loadList, submitDataGridAction, homeCloseWindow } from '@/api/common.js'
import pagination from '@/components/pagination.vue'
import add from '@/pages/jiaoxue/jiaoxuedudao/tingkejilu/add.vue'
import edit from '@/pages/jiaoxue/jiaoxuedudao/tingkejilu/edit.vue'
import detail from '@/pages/jiaoxue/jiaoxuedudao/tingkejilu/detail.vue'
const props = defineProps({ open: { type: String, required: true }, row: { type: Object, required: false } })
const emits = defineEmits(['openReturn', 'ReturnData'])

const dataGrid = ref({
  parms: {},
  data: [],
  pagination: {},
  loading: false,
  orderBy: { prop: 'kcmc', order: 'ascending' },
  multipleSelection: [],
  sortChange: function (column) {
    dataGrid.value.orderBy.prop = column.prop
    dataGrid.value.orderBy.order = column.order
    bindTable()
  },
  selectionChange: function (selection) {
    dataGrid.value.multipleSelection = selection.map((item) => item.id)
  }
})
const bindTable = async (pageNo, pageSize) => {
  loadList({
    url: '/api/v2/jiaowu/tingkejilu/pagelist',
    pageNo: pageNo || 1,
    pageSize: pageSize || 100,
    dataGrid: dataGrid.value,
    loadSuccess: function (res) {
      dataGrid.value.multipleSelection = []
    }
  })
}

// 弹窗
const row = ref()
const openAdd = ref(false)
const openEdit = ref(false)
const openDetail = ref(false)
const openList = ref(false)

// 删除
const remove = async () => {
  submitDataGridAction({
    url: '/api/v2/jiaowu/tingkejilu',
    dataGrid: dataGrid.value,
    confirmTitle: '确定要删除吗?',
    method: 'delete',
    callback: function (res) {
      bindTable()
    }
  })
}
watch(
  () => props.open,
  () => {
    if (props.open === 'tingkejilu') {
      openList.value = true
      bindTable()
    } else {
      openList.value = false
    }
  },
  { deep: true, immediate: true }
)
</script>
